let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ehBKN")).then(() => parcelRequire('28dfS'));